import React from "react";
import './Conhecimentos.css';
import { FaJs, FaNodeJs, FaReact } from "react-icons/fa";
import { SiMongodb, SiPostgresql, SiTailwindcss } from "react-icons/si";

const skills = [
    {
        icon: <FaJs />,
        iconColor: "#F7DF1E",
        iconBg: "rgba(247, 223, 30, 0.12)",
        title: "JavaScript",
        description: "Linguagem de programação orientada a eventos e tipagem dinâmica. Base do desenvolvimento web moderno, utilizada tanto no front-end quanto no back-end.",
    },
    {
        icon: <FaNodeJs />,
        iconColor: "#339933",
        title: "Node.js",
        description: "Ambiente de execução JavaScript no servidor. Permite criar APIs RESTful, manipular arquivos e integrar bancos de dados com alta eficiência.",
    },
    {
        icon: <FaReact />,
        iconColor: "#61DAFB",
        iconBg: "rgba(97, 218, 251, 0.1)",
        title: "React",
        description: "Biblioteca JavaScript para criação de interfaces de usuário. Baseada em componentes reutilizáveis com Virtual DOM e suporte a aplicações SPA.",
    },
    {
        icon: <SiTailwindcss />,
        iconColor: "#06B6D4",
        iconBg: "rgba(6, 182, 212, 0.1)",
        title: "Tailwind CSS",
        description: "Framework CSS utilitário que permite criar interfaces modernas e responsivas com rapidez e consistência visual, sem sair do HTML.",
    },
    {
        icon: <SiMongodb />,
        iconColor: "#47A248",
        title: "MongoDB",
        description: "Banco de dados NoSQL orientado a documentos. Armazena dados em formato BSON, ideal para aplicações modernas que exigem flexibilidade e escalabilidade.",
    },
    {
        icon: <SiPostgresql />,
        iconColor: "#0078D4",
        title: "PostgreSQL",
        description: "Banco de dados SQL, com realcionamentos entre tabelas, muito versatil e escalavel.",
    },
    {
        icon: <span className="text-icon">PA</span>,
        iconColor: "#742774",
        title: "Power Apps",
        description: "Plataforma Microsoft para criação de aplicações empresariais low-code. Ideal para automações, sistemas internos e integração com dados corporativos.",
    },
    {
        icon: <span className="text-icon">SP</span>,
        iconColor: "#0078D4",
        title: "SharePoint",
        description: "Plataforma Microsoft de colaboração para gerenciamento de documentos, portais corporativos e integração com ferramentas do Microsoft 365.",
    },
];

export default function Conhecimentos() {
    return (
        <div className="skills-grid">
            {skills.map((skill, index) => (
                <article className="skill-card" key={index}>
                    <div
                        className="skill-icon"
                        style={{
                            color: skill.iconColor,
                            background: skill.iconBg || `${skill.iconColor}1a`,
                        }}
                    >
                        {skill.icon}
                    </div>
                    <h3 className="skill-title">{skill.title}</h3>
                    <p className="skill-desc">{skill.description}</p>
                </article>
            ))}
        </div>
    );
}